import { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Form.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import Table from "./Table";
import ExcelData from "../ExcelUpload/ExcelData";
import Job from "../Job/Job";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";

// Module-level variable to persist finalDataList across navigation but reset on refresh
let persistedFinalDataList = [];

function UpdateItem({
  formData,
  setFormData,
  fetchedData,
  setFetchedData,
  profile,
  setProfile,
  moldId,
  thickness,
  setThickness,
  width,
  setWidth,
  length,
  setLength,
  Qty,
  setQty,
}) {
  const { tenantId } = useParams();
  const location = useLocation();
  const [licenseValid, setLicenseValid] = useState(false);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  // Initialize finalDataList from the module-level variable or default to empty array
  const [finalDataList, setFinalDataList] = useState(persistedFinalDataList);

  const [showForm, setShowForm] = useState(false);
  const [FS, setFS] = useState([]);
  const [BLK, setBLK] = useState([]);
  const [LP, setLP] = useState([]);
  const [addMoldResponse, setAddMoldResponse] = useState(null);
  const [fetchedMolds, setFetchedMolds] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [fullData, setFullData] = useState([]);
  let matchingArray = null;
  const [ItemPeriteration, setItemPeriteration] = useState([]);
  let updatedData = [];
  let OldItemPeriteration = [];
  let newItemPeriteration = [];
  const [newFinalDataList, setnewFinalDataList] = useState([]);
  const [partNumsArr, setpartNumsArr] = useState([]);
  const [company, setCompany] = useState(null);
  useEffect(() => {
    console.log("API URI:", process.env.REACT_APP_SERVER_URL);

    const checkLicense = async () => {
      if (!tenantId) return;
      const pathParts = location.pathname.split("/");
      const foundCompany = pathParts.at(-1) || null; // e.g. /form/:tenantId/:company
      setCompany(foundCompany);
      console.log("Company:", company); // undefined if not provided

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/license/validate?tenantId=${tenantId}`,
        );

        if (response.data.isValid) {
          setLicenseValid(true);
        } else {
          setLicenseValid(false);
          // navigate("/Error"); // Redirect to error page
        }
      } catch (error) {
        console.error("License validation failed:", error);
        // navigate("/Error"); // Redirect if API fails
      }
    };

    checkLicense();
  }, [tenantId, navigate]);
  useEffect(() => {
    console.log("Company (updated):", company);
  }, [company]);
  // Hide slider panel on mount
  useEffect(() => {
    const sliderPanel = document.querySelector(".slider-panel");
    if (sliderPanel) {
      sliderPanel.style.display = "none";
    }
  }, []);

  // Reset arrays when fetchedData changes
  useEffect(() => {
    if (fetchedData?.itemIdsPerIteration?.length > 0) {
      if (profile === "FS") {
        setFS([]);
      } else {
        setLP([]);
      }
      setBLK([]);
    }
  }, [fetchedData, profile]);

  // Process data and fetch molds
  useEffect(() => {
    if (finalDataList.length > 0) {
      processData(finalDataList);
    } else if (fetchedData?.itemIdsPerIteration?.length > 0) {
      processData(fetchedData);
    }

    fetch(`${process.env.REACT_APP_SERVER_URL}/Molds?company=${company}`)
      .then((response) => response.json())
      .then((data) => {
        const uniqueMolds = data.filter(
          (mold, index, self) =>
            index === self.findIndex((m) => m.part_Thickness === mold.part_Thickness),
        );
        setFetchedMolds(uniqueMolds);
      })
      .catch((error) => console.error(error));
  }, [fetchedData, finalDataList, company]);

  // Update the persistedFinalDataList whenever finalDataList changes
  useEffect(() => {
    persistedFinalDataList = finalDataList;
    console.log("Updated Final Combined List (After State Updates):", finalDataList);
  }, [finalDataList]);

  const initializeArrays = (length) => {
    return new Array(length).fill(null).map(() => []);
  };

  const processData = (data) => {
    const length =
      finalDataList?.length > 0 ? finalDataList.length : data.itemIdsPerIteration.length;
    let fsArray = initializeArrays(length);
    let blkArray = initializeArrays(length);
    let lPArray = initializeArrays(length);
    const sourceData = finalDataList?.length > 0 ? finalDataList : data.itemIdsPerIteration;

    for (let i = 0; i < sourceData.length; i++) {
      for (let j = 0; j < sourceData[i]?.length; j++) {
        const item = sourceData[i][j];
        if (profile === "FS") {
          fsArray[i].push(item);
        } else {
          lPArray[i].push(item);
        }
      }
    }

    if (profile === "FS") {
      setFS(fsArray);
    } else {
      setLP(lPArray);
    }
    setBLK(blkArray);
  };

  let SpecificMold = "";

  function GetInfo() {
    document.querySelectorAll(".table-parent").forEach((div, index) => {
      if (!div.classList.contains("event-listener-attached")) {
        div.addEventListener("click", function () {
          const moldIDElement = document.querySelectorAll("h4")[index];
          const moldID = moldIDElement?.textContent.trim();
          SpecificMold = moldID;

          if (!fetchedData || !Array.isArray(fetchedData.itemIdsPerIteration)) {
            console.error("fetchedData.itemIdsPerIteration is missing or not an array.");
            return;
          }

          matchingArray = findMatchingArray(fetchedData.itemIdsPerIteration, moldID);
          if (!matchingArray || matchingArray == null) {
            matchingArray = findMatchingArray(finalDataList, moldID);
          }

          if (matchingArray) {
            console.log("Matching Array:", matchingArray);
          } else {
            console.log("No array contains the specified MoldID.");
          }

          openSliderPanel(matchingArray);
        });
        div.classList.add("event-listener-attached");
      }
    });
  }

  const findMatchingArray = (listOfLists, moldID) => {
    for (const array of listOfLists) {
      if (!Array.isArray(array)) {
        console.warn("Skipping invalid array:", array);
        continue;
      }
      const found = array.some((mold) => mold.partLot_MoldID_c === moldID);
      if (found) {
        return array;
      }
    }
    return null;
  };

  let originalData = [];
  const openSliderPanel = (data) => {
    const sliderPanel = document.querySelector(".slider-panel");
    if (!sliderPanel) {
      console.error("Slider panel element not found.");
      return;
    }

    if (data && Array.isArray(data)) {
      originalData = data.map((item) => ({ ...item }));
      const contentArea = sliderPanel.querySelector(".content");
      if (contentArea) {
        const groupedData = data.reduce((acc, item) => {
          const existingItem = acc.find(
            (i) =>
              i.partLot_Depth_c === item.partLot_Depth_c &&
              i.partLot_Width_c === item.partLot_Width_c &&
              i.partLot_Length_c === item.partLot_Length_c &&
              (i.partLot_Density_c ?? i.partLot_Denisty_c) ===
                (item.partLot_Density_c ?? item.partLot_Denisty_c) &&
              (i.partLot_FC_c ?? i["partLot_F'C_c"]) ===
                (item.partLot_FC_c ?? item["partLot_F'C_c"]) &&
              i.partLot_Type_c === item.partLot_Type_c,
          );
          if (existingItem) {
            existingItem.count += 1;
          } else {
            acc.push({ ...item, count: 1 });
          }
          return acc;
        }, []);

        const tableRows = groupedData
          .map(
            (item, index) => `
            <tr key="${index}" style="cursor:pointer">
              <td>
                <input 
                  type="number" 
                  value="${item.count}" 
                  class="editable-count" 
                  oninput="updateCount(this, ${index})"
                  style="width: 60px;"
                />
              </td>
              <td>${item.partLot_LotNum}</td>
              <td>${item.partLot_BuildingType_c}</td>
              <td>${parseInt(item.partLot_Depth_c)}</td>
              <td>${parseInt(item.partLot_Width_c)}</td>
              <td>${parseInt(item.partLot_Length_c)}</td>
              <td>${item.partLot_Density_c ?? item.partLot_Denisty_c ?? ""}</td>
              <td>${item.partLot_FC_c ?? item["partLot_F'C_c"] ?? ""}</td>
              <td>${item.partLot_Type_c ?? ""}</td>
            </tr>
          `,
          )
          .join("");

        const contentHTML = `
          <table class="table table-hover table-bordered" id="data-table">
            <thead>
              <tr>
                <th class="blue-table-header">Count</th>
                <th class="blue-table-header">Element ID</th>
                <th class="blue-table-header">Element Type</th>
                <th class="blue-table-header">Thickness</th>
                <th class="blue-table-header">Width</th>
                <th class="blue-table-header">Length</th>
                <th class="blue-table-header">Density</th>
                <th class="blue-table-header">F'C</th>
                <th class="blue-table-header">Type</th>
              </tr>
            </thead>
            <tbody>
              ${tableRows}
            </tbody>
          </table>
          <div class="d-flex">
            <button id="add-row-button" class="submit-btn ro d-block m-2 rounded">Add New Element</button>
            <button id="save-button" class="submit-btn ro d-block m-2 rounded">Save</button>
          </div>
        `;
        const moldIdSlide = sliderPanel.querySelector(".MoldIdSlide");
        if (moldIdSlide) {
          moldIdSlide.textContent = SpecificMold || "No Specific Mold";
        }
        contentArea.innerHTML = contentHTML;

        const addRowButton = document.getElementById("add-row-button");
        addRowButton.addEventListener("click", addNewRow);
        const saveButton = document.getElementById("save-button");
        saveButton.addEventListener("click", saveData);
      }
    } else {
      console.error("Data is not a valid array.", data);
    }
    sliderPanel.style.display = "block";
  };

  window.updateCount = (input, index) => {
    const newValue = parseInt(input.value);
    if (isNaN(newValue) || newValue < 0) {
      console.error("Invalid count value. Count must be greater than or equal to 0.");
      input.value = 0;
      return;
    }
    console.log(`Updated count for row ${index}:`, newValue);
  };

  let currentData = [];
  const saveData = () => {
    const rows = document.querySelectorAll(".slider-panel .table tbody tr");
    let newCurrentData = [];

    rows.forEach((row) => {
      const partLot_Count_c = parseInt(row.querySelector("input").value);
      const partLot_LotNum = row.children[1].textContent;
      const partLot_BuildingType_c = row.children[2].textContent;
      const partLot_Depth_c = row.children[3].textContent;
      const partLot_Width_c = row.children[4].textContent;
      const partLot_Length_c = row.children[5].textContent;
      const partLot_Density_c = row.children[6].textContent;
      const partLot_FC_c = row.children[7].textContent;
      const partLot_Type_c = row.children[8].textContent;
      const PartLot_MoldID_c = SpecificMold;

      let partLot_TOPDCROS_c = null,
        partLot_TOPECROS_c = null,
        partLot_TOPLong_c = null;
      let partLot_BOTDCROS_c = null,
        partLot_BOTECROS_c = null,
        partLot_BOTLong_c = null;
      let partLot_Project_c = null,
        partLot_WBS_c = null,
        partLot_ElementStatus_c = null;

      const matchingItem = matchingArray?.find((item) => item.partLot_LotNum === partLot_LotNum);

      if (matchingItem) {
        partLot_TOPDCROS_c = matchingItem.partLot_TOPDCROS_c;
        partLot_TOPECROS_c = matchingItem.partLot_TOPECROS_c;
        partLot_TOPLong_c = matchingItem.partLot_TOPLong_c;
        partLot_BOTDCROS_c = matchingItem.partLot_BOTDCROS_c;
        partLot_BOTECROS_c = matchingItem.partLot_BOTECROS_c;
        partLot_BOTLong_c = matchingItem.partLot_BOTLong_c;
        partLot_Project_c = matchingItem.partLot_Project_c;
        partLot_WBS_c = matchingItem.partLot_WBS_c;
        partLot_ElementStatus_c = matchingItem.partLot_ElementStatus_c;
      }

      if (partLot_Count_c > 0) {
        newCurrentData.push({
          partLot_LotNum,
          partLot_BuildingType_c,
          partLot_Depth_c,
          partLot_Width_c,
          partLot_Length_c,
          partLot_Count_c,
          partLot_Density_c,
          partLot_FC_c,
          partLot_Type_c,
          PartLot_MoldID_c,
          partLot_TOPDCROS_c,
          partLot_TOPECROS_c,
          partLot_TOPLong_c,
          partLot_BOTDCROS_c,
          partLot_BOTECROS_c,
          partLot_BOTLong_c,
          partLot_ElementStatus_c,
          partLot_WBS_c,
          partLot_Project_c,
        });
      }
    });

    let updatedData = newCurrentData.filter(
      (item) => item?.partLot_LotNum && item?.partLot_LotNum.trim() !== "",
    );
    if (matchingArray?.length > 0) {
      updatedData = updatedData.map((item) => ({
        ...item,
        partLot_ElementStatus_c:
          item.partLot_ElementStatus_c ?? matchingArray[0].partLot_ElementStatus_c,
        partLot_WBS_c: item.partLot_WBS_c ?? matchingArray[0].partLot_WBS_c,
        partLot_Project_c: item.partLot_Project_c ?? matchingArray[0].partLot_Project_c,
      }));
    }
    updatedData = [...updatedData, ...addedRows];
    console.log("Updated Data:", updatedData);
    console.log("FetchedData:", fetchedData);

    setItemPeriteration((prev) => {
      OldItemPeriteration = fetchedData.itemIdsPerIteration;
      console.log("Updated ItemPeriteration:", OldItemPeriteration);
      updateItem(updatedData, 1);
      return OldItemPeriteration;
    });

    closeSliderPanel();
  };

  const addedRows = [];
  const addNewRow = () => {
    const tableBody = document.querySelector("#data-table tbody");
    if (tableBody) {
      const newRow = document.createElement("tr");
      const rowData = {
        partLot_Count_c: 1,
        partLot_LotNum: "",
        partLot_BuildingType_c: "",
        partLot_Depth_c: 0,
        partLot_Width_c: 0,
        partLot_Length_c: 0,
        partLot_Density_c: 0,
        partLot_FC_c: 0,
        partLot_Type_c: "",
        PartLot_MoldID_c: SpecificMold,
      };

      addedRows.push(rowData);

      newRow.innerHTML = `
        <td>
          <input 
            type="number" 
            value="1" 
            class="editable-count" 
            style="width: 60px;"
          />
        </td>
        <td><input type="text" class="editable-field" placeholder="Enter Element ID" /></td>
        <td><input type="text" class="editable-field" placeholder="Enter Element Type" /></td>
        <td><input type="number" class="editable-field" placeholder="Enter Thickness" /></td>
        <td><input type="number" class="editable-field" placeholder="Enter Width" /></td>
        <td><input type="number" class="editable-field" placeholder="Enter Length" /></td>
        <td><input type="number" class="editable-field" placeholder="Enter Density" /></td>
        <td><input type="number" class="editable-field" placeholder="Enter F'C" /></td>
        <td><input type="text" class="editable-field" placeholder="Enter Type" /></td>
      `;

      tableBody.appendChild(newRow);

      const inputs = newRow.querySelectorAll("input");
      inputs.forEach((input, index) => {
        input.addEventListener("input", (event) => {
          const value = event.target.value;
          switch (index) {
            case 0:
              rowData.partLot_Count_c = parseInt(value) || 0;
              break;
            case 1:
              rowData.partLot_LotNum = value;
              break;
            case 2:
              rowData.partLot_BuildingType_c = value;
              break;
            case 3:
              rowData.partLot_Depth_c = parseFloat(value) || 0;
              break;
            case 4:
              rowData.partLot_Width_c = parseFloat(value) || 0;
              break;
            case 5:
              rowData.partLot_Length_c = parseFloat(value) || 0;
              break;
            case 6:
              rowData.partLot_Density_c = parseFloat(value) || 0;
              break;
            case 7:
              rowData.partLot_FC_c = parseFloat(value) || 0;
              break;
            case 8:
              rowData.partLot_Type_c = value;
              break;
          }

          const rowIndex = currentData.indexOf(rowData);
          if (rowIndex === -1) {
            currentData.push(rowData);
          } else {
            currentData[rowIndex] = rowData;
          }
          console.log("Updated Current Data:", currentData);
        });
      });

      console.log("Added Row Data:", rowData);
    } else {
      console.error("Table body not found.");
    }
  };

  const closeSliderPanel = () => {
    const sliderPanel = document.querySelector(".slider-panel");
    if (sliderPanel) {
      sliderPanel.style.display = "none";
    }
    console.log(matchingArray);
  };

  const updateItem = (array, NewQty) => {
    const itemData = [];

    if (NewQty !== null && NewQty !== undefined && NewQty !== "" && NewQty !== 0) {
      Qty = NewQty;
    }
    if (array && array.length > 0) {
      array.forEach((item) => {
        itemData.push({
          PartLot_Company: item.PartLot_Company,
          PartLot_LotNum: item.partLot_LotNum,
          PartLot_PartNum: item.partLot_BuildingType_c,
          PartLot_BuildingType_c: item.partLot_BuildingType_c,
          PartLot_Count_c: item.partLot_Count_c,
          PartLot_Depth_c: item.partLot_Depth_c,
          PartLot_Length_c: item.partLot_Length_c,
          PartLot_Width_c: item.partLot_Width_c,
          PartLot_Density_c: item.partLot_Density_c ?? item.partLot_Denisty_c,
          PartLot_FC_c: item.partLot_FC_c ?? item["partLot_F'C_c"],
          PartLot_Type_c: item.partLot_Type_c,
          PartLot_Project_c: item.partLot_Project_c,
          PartLot_WBS_c: item.partLot_WBS_c,
          PartLot_ElementStatus_c: item.partLot_ElementStatus_c,
          PartLot_MoldID_c: item.PartLot_MoldID_c || "",
          PartLot_BOTLong_c: item.PartLot_BOTLong_c || item.partLot_BOTLong_c || "",
          PartLot_BOTECROS_c: item.PartLot_BOTECROS_c || item.partLot_BOTECROS_c || "",
          PartLot_BOTDCROS_c: item.PartLot_BOTDCROS_c || item.partLot_BOTDCROS_c || "",
          PartLot_TOPLong_c: item.PartLot_TOPLong_c || item.partLot_TOPLong_c || "",
          PartLot_TOPECROS_c: item.PartLot_TOPECROS_c || item.partLot_TOPECROS_c || "",
          PartLot_TOPDCROS_c: item.PartLot_TOPDCROS_c || item.partLot_TOPDCROS_c || "",
        });
      });
    }

    const itemDataJson = JSON.stringify(itemData);

    if (SpecificMold !== "") {
      moldId = SpecificMold;
    }

    const requestBody = {
      moldId,
      thickness,
      Qty,
      width,
      length,
      itemDataJson,
      ParamItemType: profile,
      company: company,
    };

    console.log("Request Body:", JSON.stringify(requestBody));
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    };

    if (profile === "FS") {
      fetch(
        `${process.env.REACT_APP_SERVER_URL}/Test/process-items?thickness=${thickness}&width=${width}&length=${length}&qty=${Qty}&ParamItemType=${profile}`,
        requestOptions,
      )
        .then((response) => response.json())
        .then(async (data) => {
          newItemPeriteration = data.itemIdsPerIteration;
          const areArraysIdentical =
            JSON.stringify(data.itemIdsPerIteration) === JSON.stringify(OldItemPeriteration);

          if (OldItemPeriteration.length > 0 && !areArraysIdentical) {
            finaldata(array);
          }

          if (profile === "FS") {
            setFS([]);
          } else {
            setLP([]);
          }
          setBLK([]);
          setFetchedData(data);
          setErrorMessage(data.errorMessage || "");
        })
        .catch((error) => console.error(error));
    } else {
      fetch(
        `${process.env.REACT_APP_SERVER_URL}/LP?thickness=${thickness}&width=${width}&length=${length}&qty=${Qty}&ParamItemType=${profile}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestBody),
        },
      )
        .then((data) => data.json())
        .then(async (data) => {
          setLP([]);
          setBLK([]);
          setErrorMessage(data.errorMessage || "");
          const LPArray = new Array(data.itemIdsPerIteration.length).fill(null).map(() => []);
          const blkArray = new Array(data.itemIdsPerIteration.length).fill(null).map(() => []);

          for (let i = 0; i < data.itemIdsPerIteration.length; i++) {
            for (let j = 0; j < data.itemIdsPerIteration[i].length; j++) {
              const item = data.itemIdsPerIteration[i][j];
              if (item["partLot_BuildingType_c"] === "BLK") {
                blkArray[i].push(item);
              } else {
                LPArray[i].push(item);
              }
            }
          }

          setLP(LPArray);
          setBLK(blkArray);
          setFetchedData(data);
        })
        .catch((error) => console.error(error));
    }
  };

  const finaldata = (updatedDatae) => {
    const firstUpdatedPartLotMoldID =
      updatedDatae.length > 0 ? updatedDatae[0].PartLot_MoldID_c : null;

    setFinalDataList((prevFinalDataList) => {
      const baseList = prevFinalDataList.length > 0 ? prevFinalDataList : OldItemPeriteration;
      const updatedList = baseList.map((originalList) => {
        if (
          originalList.length > 0 &&
          originalList[0].partLot_MoldID_c === firstUpdatedPartLotMoldID
        ) {
          return structuredClone(newItemPeriteration[0]);
        }
        return structuredClone(originalList);
      });
      return updatedList;
    });

    setTimeout(() => {
      console.log("Final Combined List:", finalDataList);
    }, 0);
  };

  const toggleForm = () => {
    setShowForm(!showForm);
  };

  const handleMoldSelect = (e) => {
    let dimArray = e.target.value.split("-");
    const selectedThickness = dimArray[0];
    const selectedLength = dimArray[2];
    const selectedWidth = dimArray[1];

    setThickness(selectedThickness);
    setWidth(selectedWidth);
    setLength(selectedLength);
  };

  return (
    <div className="body-container mt-5 rounded border p-1">
      <div className="slider-panel">
        <div className="d-flex justify-content-between align-items-center slidePanel-Title">
          <h5 className="MoldIdSlide"></h5>
          <button className="close-btn" onClick={closeSliderPanel}>
            <FaTimes size={20} style={{ cursor: "pointer", color: "black" }} />
          </button>
        </div>
        <div className="border mt-2 p-1">
          <div className="bg p-3 rounded">
            <div className="content m-3"></div>
          </div>
        </div>
      </div>

      <ExcelData
        setpartnum={setpartNumsArr}
        formData={formData}
        setFormData={setFormData}
        tenant={tenantId}
        licenseValid={licenseValid}
        disabled={!licenseValid}
        company={company} // disable when license is invalid
      />
      <div className="Form-Panel m-1 px-2 py-2">
        <div className="title-border-bottom">
          <button
            className="toggle-btn my-3 mx-5"
            onClick={toggleForm}
            style={{
              cursor: licenseValid ? "pointer" : "not-allowed",
              color: licenseValid ? "black" : "gray",
            }}
          >
            <i
              className="bi bi-arrow-down-short"
              style={{
                fontSize: "2rem",
                fontWeight: "bolder",
                color: licenseValid ? "black" : "gray",
              }}
            ></i>
            Mold Details
          </button>
        </div>

        {showForm && licenseValid && (
          <div className="mb-2">
            <form className="p-2 m-2 form-bg border rounded">
              <div className="container">
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group my-2">
                      <label htmlFor="moldSelect">Mold</label>
                      <select
                        type="text"
                        id="moldSelect"
                        className="form-select"
                        onChange={(e) => {
                          handleMoldSelect(e);
                        }}
                        defaultValue=""
                        name="optionlist"
                      >
                        <option className="select" value="" disabled>
                          <i className="bi bi-caret-down"></i>
                        </option>
                        {fetchedMolds &&
                          fetchedMolds?.map((mold, index) => (
                            <option
                              key={index}
                              value={`${parseInt(mold.part_Thickness)}-${parseInt(mold.part_PartWidth)}-${parseInt(mold.part_PartLength)}`}
                            >
                              Mold A
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group my-2">
                      <label htmlFor="quantityInput">Quantity</label>
                      <input
                        id="quantityInput"
                        className="form-control"
                        placeholder=""
                        value={Qty}
                        onChange={(e) => setQty(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group my-2">
                      <label htmlFor="profileSelect">Mold Type</label>
                      <select
                        id="profileSelect"
                        className="form-select"
                        onChange={(e) => {
                          setProfile(e.target.value);
                          //setFetchedData(null);
                          // finalDataList.length=0;
                        }}
                        defaultValue=""
                        name="optionlist"
                      >
                        <option className="select" value="" disabled>
                          <i className="bi bi-caret-down"></i>
                        </option>
                        <option key={0} value={`FS`}>
                          FS
                        </option>
                        <option key={1} value={`LP`}>
                          LP
                        </option>
                        <option key={2} value={`VP`}>
                          VP
                        </option>
                        <option key={3} value={`HP`}>
                          HP
                        </option>
                        <option key={4} value={`MP`}>
                          MP
                        </option>
                        <option key={5} value={`PR`}>
                          PR
                        </option>
                        <option key={6} value={`ST SLAB`}>
                          ST SLAB
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group my-2">
                      <label htmlFor="lengthInput">Length</label>
                      <input
                        id="lengthInput"
                        className="form-control"
                        placeholder=""
                        value={length}
                        onChange={(e) => setLength(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group my-2">
                      <label htmlFor="thicknessInput">Thickness</label>
                      <input
                        id="thicknessInput"
                        className="form-control"
                        placeholder=""
                        value={thickness}
                        onChange={(e) => setThickness(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group my-2">
                      <label htmlFor="widthInput">Width</label>
                      <input
                        id="widthInput"
                        className="form-control"
                        placeholder=""
                        value={width}
                        onChange={(e) => setWidth(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group my-2">
                      <label htmlFor="volumeInput">Volume</label>
                      <div className="input-group">
                        <input
                          id="volumeInput"
                          className="form-control"
                          placeholder=""
                          value={((thickness / 1000) * (width / 1000) * (length / 1000)).toFixed(2)}
                          disabled
                        />
                        <div className="input-group-append">
                          <span className="input-group-text">m³</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex">
                <button
                  type="button"
                  className="submit-btn ro d-block m-2 rounded"
                  onClick={() => {
                    setFetchedData(null);
                    finalDataList.length = 0; // Reset finalDataList to an empty array
                    updateItem(); // Call updateItem
                  }}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
      {addMoldResponse && (
        <div className="mt-4 alert alert-info" role="alert">
          Mold added successfully with ID: {addMoldResponse.id}
        </div>
      )}
      {errorMessage && <div className="error-message">{errorMessage}</div>}
      <Table
        fetchedData={finalDataList.length > 0 ? finalDataList : fetchedData}
        GetInfo={GetInfo}
        navigate={navigate}
        profile={profile}
        FS={FS}
        BLK={BLK}
        length={length}
        width={width}
        thickness={thickness}
        LP={LP}
        setIsOpen={setIsOpen}
        closeSliderPanel={closeSliderPanel}
        company={company}
      />
      {/*<Quote partNumArr={partNumsArr} licenseValid={licenseValid} company={company}/>*/}
      <Job partNumArr={partNumsArr} licenseValid={licenseValid} company={company} />
      <SlidingPane
        className="slidingPanel"
        overlayClassName="some-custom-overlay-class"
        isOpen={isOpen}
        title="Mold Optimization"
        width="500px"
        onRequestClose={() => {
          setIsOpen(false);
        }}
      >
        <div className="table-bg p-4 mt-3 m-1">
          <h4>Suggestion</h4>
          <label htmlFor="Type" style={{ display: "inline-block", fontSize: "20px" }}>
            Type
          </label>
          <input
            name="Type"
            disabled={true}
            className="form-control my-2 w-25 d-inline m-1"
            placeholder="Type"
            value={"BLK"}
          />
          <label htmlFor="Count" style={{ display: "inline-block", fontSize: "20px" }}>
            Count
          </label>
          <input
            name="Count"
            disabled={true}
            className="form-control my-2 w-25 d-inline m-1"
            placeholder="Count"
            value={7}
          />
          <div>
            <button type="button" className="submit-btn ro d-block m-2 rounded">
              Accept Suggestion
            </button>
          </div>
        </div>
        <div className="table-bg p-4 mt-3 m-1">
          <h4>Manual placement</h4>
          <label htmlFor="Type2" style={{ display: "inline-block", fontSize: "20px" }}>
            Type
          </label>
          <select className="form-control my-2 w-25 d-inline m-1" defaultValue="" name="Type2">
            <option key={0} value={`FS+BLK`}>
              FS
            </option>
            <option key={1} value={`LP`}>
              LPS
            </option>
          </select>
          <label htmlFor="Count2" style={{ display: "inline-block", fontSize: "20px" }}>
            Count
          </label>
          <input
            name="Count2"
            disabled={false}
            className="form-control my-2 w-25 d-inline m-1"
            placeholder="Count"
          />
          <div>
            <button type="button" className="submit-btn ro d-block m-2 rounded">
              Accept
            </button>
          </div>
        </div>
      </SlidingPane>
    </div>
  );
}

export default UpdateItem;
